





























import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import Component from 'vue-class-component'

@Component({
  name: 'Member',
})
export default class Member extends Vue {
  @Prop({
    required: true,
    type: String,
  })
  public readonly name!: string

  get id() {
    return this.name.toLowerCase()
  }

  get src() {
    return `/images/team/${this.id}_2x.jpg`
  }

  get srcset() {
    return `/images/team/${this.id}.jpg 1x, /images/team/${this.id}_2x.jpg 2x`
  }
}
